import { ZMetaNode } from "../types/metaTypes";

export const ex1metaGrid = {
  type: "grid",
  items: [
    {
      type: "field",
      name: "actual",
      title: "Актуальный",
      component: { type: "Checkbox" },
    },
    {
      type: "field",
      name: "units",
      title: "Единица измерения (кг/ литры/ упк)",
      component: {
        type: "Select",
        options: [
          { value: "kg", label: "кг" },
          { value: "l", label: "литры" },
          { value: "pack", label: "упк" },
        ],
      },
    },
    {
      type: "field",
      name: "unitMass",
      title: "Граммовка ед.товара ({{units.label}})",
      component: {
        type: "InputNumber",
        min: 0,
      },
    },
    {
      type: "field",
      name: "fullName",
      title: "Полное наименование товара (с ед.изм.)",
      component: { type: "Input", addonAfter: "{{units.label}}" },
      rules: [{ type: "required", msg: "Требуется наименование" }],
    },
    {
      type: "field",
      name: "commodityCode",
      title: "Код Товарной позиции",
      component: { type: "Input" },
      rules: [
        {
          type: "pattern",
          pattern: /^\d*$/.toString(),
          msg: "Только цифры",
        },
      ],
      disableIf: { type: "boolField", path: "actual", inv: true },
    },
    {
      type: "field",
      name: "intValue",
      title: "Целое число",
      component: { type: "InputNumber", precision: 0 },
      rules: [{ type: "min", minValue: 0 }],
      hideIf: { type: "boolField", path: "actual", inv: true },
    },
    {
      type: "field",
      name: "packType",
      title: "Тип упаковки",
      component: { type: "Input" },
      hideIf: { type: "fieldValue", op: "!=", path: "units", value: "pack" },
    },
    {
      type: "field",
      name: "comment",
      title: "Комментарий",
      component: { type: "Input" },
      colSpan: 3,
    },

    {
      type: "field",
      name: "minMass",
      title: "Минимальная масса",
      component: { type: "InputNumber", addonAfter: "кг", precision: 2 },
      rules: [{ type: "min", minValue: 10 }],
    },
    {
      type: "field",
      name: "maxMass",
      title: "Максимальная масса",
      component: { type: "InputNumber", addonAfter: "кг", precision: 2 },
      rules: [
        {
          type: "cmpField",
          op: ">",
          path: "minMass",
          msg: "Должно быть больше {{minMass}}",
        },
      ],
    },

    {
      type: "field",
      name: "contracts",
      title: "Договора с поставщиками",
      colSpan: "*",
      component: {
        type: "CollapseList",
        row: {
          layout: {
            type: "grid",
            items: [
              {
                name: "contractType",
                type: "field",
                title: "Вид договора",
                component: { type: "Input" },
              },
              {
                name: "number",
                type: "field",
                title: "Номер",
                component: { type: "Input" },
              },
              {
                name: "fullName",
                type: "field",
                title: "Полное название",
                component: { type: "Input" },
              },
              {
                name: "date1",
                type: "field",
                title: "Дата начала",
                component: { type: "Date" },
              },
              {
                name: "date2",
                type: "field",
                title: "Дата окончания",
                component: {
                  type: "Date",
                  placeholder: "Веберите дату окончания",
                },
                rules: [
                  {
                    type: "cmpField",
                    op: ">=",
                    path: "@date1",
                    msg: "Не раньше даты начала",
                  },
                ],
              },
              {
                name: "terms",
                title: "Условия договора",
                type: "field",
                component: {
                  type: "CollapseList",
                  row: {
                    layout: {
                      type: "grid",
                      items: [
                        {
                          type: "field",
                          name: "field1",
                          title: "Поле 1",
                          component: { type: "Input" },
                          rules: [
                            {
                              type: "pattern",
                              pattern: /^\d*$/.toString(),
                              msg: "Разрешены только буквы",
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
  ] as ZMetaNode[],
} satisfies ZMetaNode;

export const ex1metaSubGrid = JSON.parse(JSON.stringify(ex1metaGrid));
ex1metaSubGrid.items.splice(1, 2, {
  type: "grid",
  title: "Группа полей (зависит от поля {{actual.title}})",
  items: ex1metaGrid.items.slice(1, 3),
  colSpan: "*",
  disableIf: { type: "boolField", path: "actual", inv: true },
} satisfies ZMetaNode);
